var _ = require('underscore');
var $ = require('jquery');

function refreshEmailBody() {
    var emailForm = $('.modal-content #form_send');
    var orderForm = $('#simple_form');

    // sets default "Loading..."
    $('.modal-content #email_calculation_textarea').html(Translator.trans('Loading...'));

    // hides button to resend
    $('#modal .block-footer button:first').hide();

    $.ajax({
        type: 'POST',
        url: RoutingS1.generate('productEmailPreview'),
        data: emailForm.serialize() + '&' + orderForm.serialize(),
        dataType: 'html',
        error: function(xhr, ajaxOptions, thrownError) {
            alert(Translator.trans('There was error. Please try again later.'));
        },
        success: function(data) {
            $('.modal-content #email_calculation_textarea').html(data);

            // show "Send button" to resend
            $('#modal .block-footer button:first').show();
        }
    });
}

function openEmailModal() {
    let buttons = {};
    buttons[Translator.trans('Send calculation')] = function(win) {
        $('.modal-content #email_calculation').val(
            $('.modal-content #calculation_details').html()
        );
        $('.modal-content #send_errors').html('');

        var emailForm = $('.modal-content #form_send');
        var orderForm = $('#simple_form');
        var data = emailForm.serialize() + '&' + orderForm.serialize();
        var uri =  emailForm.attr('action');
        var method =  emailForm.attr('method');

        // shows loader
        $('#modal .block-footer').prepend('/images/loader.gif');

        // hides button to resend
        $('#modal .block-footer button:first').hide();

        $.ajax({
            type: method,
            url: uri,
            data: data,
            dataType: 'json',
            error: function(xhr, ajaxOptions, thrownError) {
                alert(Translator.trans('There was error. Please try again later.'));
            },
            success: function(data) {
                if(data.response.responseStatus != 'success') {
                    var errors = data.response;

                    for(var i in errors) {
                        $('.modal-content #send_errors').append('<li>' + errors[i] + '</li>');
                    }
                    $('.modal-content #send_errors').show();

                    // show "Send button" to resend
                    $('#modal .block-footer button:first').show();
                }
                else {
                    $('.modal-content #send_calculation_form').html([
                        '<ul class="message success grid_12"><li>',
                        Translator.trans('Email has been sent.'),
                        '</li></ul>'
                    ].join(''));
                }

                // removes loader
                $('#modal .block-footer img').remove();
            }
        });
    };

    buttons[Translator.trans('Close')] = function(win) {
        win.closeModal();
    };

    $.modal({
        content: $('#send_calculation_form'),
        title: Translator.trans('Send calculation'),
        maxWidth: 500,
        maxHeight: 450,
        resizable: false,
        buttons: buttons
    });
    refreshEmailBody();
}

$(document).ready(function() {
    if (!_.isUndefined(openCalculation) && openCalculation) {
        openEmailModal();
    }

    $('#send_calculation').click(function() {
        if($(this).hasClass('save-order-calculation')) {
            var orderForm = $('#simple_form');

            if (productSlug) {
                $.ajax({
                    type: 'POST',
                    url: RoutingS1.generate('saveOrderForCalculation'),
                    data: orderForm.serialize() + '&product_name=' + productSlug,
                    dataType: 'json',
                    error: function(xhr, ajaxOptions, thrownError) {
                        alert(Translator.trans('There was error. Please try again later.'));
                    },
                    success: function(data) {
                        if(data.action == 'reload') {
                            document.location.href = data.url;
                        }
                        else {
                            openEmailModal();
                        }
                    }
                });
            }
        }
        else {
            openEmailModal();
        }
    });
});
